namespace Link.Masjid {
    
    @Serenity.Decorators.registerEditor()
    export class JenisAkunEditor extends Serenity.Select2Editor<object, object> {

        constructor(hidden: JQuery) {
            super(hidden, null);
            var arrJenis = [
                {
                    id: "0",
                    text: "Kas",
                    source: {
                        J: "A"/*cth: Jenis:Aset*/, T: "D"/*cth: Tipe:Debit*/
                    }
                }, {
                    id: "1",
                    text: "Bank",
                    source: {
                        J: "A"/*cth: Jenis:Aset*/, T: "D"/*cth: Tipe:Debit*/
                    }
                }, {
                    id: "2",
                    text: "Piutang",
                    source: {
                        J: "A"/*cth: Jenis:Aset*/, T: "D"/*cth: Tipe:Debit*/
                    }
                }, {
                    id: "3",
                    text: "Persediaan",
                    source: {
                        J: "A"/*cth: Jenis:Aset*/, T: "D"/*cth: Tipe:Debit*/
                    }
                }, {
                    id: "4",
                    text: "Aktiva Lancar",
                    source: {
                        J: "A"/*cth: Jenis:Aset*/, T: "D"/*cth: Tipe:Debit*/
                    }
                }, {
                    id: "5",
                    text: "Aktiva Tetap",
                    source: {
                        J: "A"/*cth: Jenis:Aset*/, T: "D"/*cth: Tipe:Debit*/
                    }
                }, {
                    id: "6",
                    text: "Akumulasi Penyusutan",
                    source: {
                        J: "A"/*cth: Jenis:Aset*/, T: "D"/*cth: Tipe:Debit*/
                    }
                }, {
                    id: "7",
                    text: "Hutang",
                    source: {
                        J: "H"/*cth: Jenis:Hutang*/, T: "K"/*cth: Tipe:Kredit*/
                    }
                }, {
                    id: "8",
                    text: "Hutang Lancar",
                    source: {
                        J: "H"/*cth: Jenis:Hutang*/, T: "K"/*cth: Tipe:Kredit*/
                    }
                }, {
                    id: "9",
                    text: "Hutang Jangka Panjang",
                    source: {
                        J: "H"/*cth: Jenis:Hutang*/, T: "K"/*cth: Tipe:Kredit*/
                    }
                }, {
                    id: "10",
                    text: "Aset Neto",
                    source: {
                        J: "M"/*cth: Jenis:Modal*/, T: "K"/*cth: Tipe:Kredit*/
                    }
                }, {
                    id: "11",
                    text: "Pendapatan",
                    source: {
                        J: "P"/*cth: Jenis:Pendapatan*/, T: "K"/*cth: Tipe:Kredit*/
                    }
                }, {
                    id: "12",
                    text: "Harga Pokok Penjualan",
                    source: {
                        J: "B"/*cth: Jenis:Beban*/, T: "D"/*cth: Tipe:Kredit*/
                    }
                }, {
                    id: "13",
                    text: "Beban",
                    source: {
                        J: "B"/*cth: Jenis:Beban*/, T: "D"/*cth: Tipe:Kredit*/
                    }
                }, {
                    id: "14",
                    text: "Pendapatan Lain-lain",
                    source: {
                        J: "P"/*cth: Jenis:Pendapatan*/, T: "K"/*cth: Tipe:Kredit*/
                    }
                }, {
                    id: "15",
                    text: "Beban Lain-lain",
                    source: {
                        J: "B"/*cth: Jenis:Beban*/, T: "D"/*cth: Tipe:Kredit*/
                    }
                }
            ]
            arrJenis.forEach((x) => {
                this.addItem(x);
            })
        }
    }
}